import NavBar from "../../components/NavBar/NavBar";
import AboutSection from "./components/Sobre/AboutClub";
import Banner from "./components/Banner/Banner";
import FeedBack from "./components/Feedback/Feedback";
import Footer from "../../components/Footer/Footer";
import BrandCarousel from "./components/Parceiros/Parceiros";
import Reviews from "./components/Depoimentos/Reviews";
const Home = () => {
    return (
        <div>
            <NavBar variant="default"/>
            <Banner/>
            <AboutSection/>
            <FeedBack/>
            <BrandCarousel/>
            <Reviews/>
            <Footer/>
        </div>
    );
};
export default Home;